import { Stack as MuiStack, StackProps as MuiStackProps } from '@mui/material';

export type StackProps<D extends React.ElementType = 'div', P = object> = MuiStackProps<D, P>;

export const Stack = MuiStack;
